import HttpServiceBase from "./http-service";

export default class InstitutionAdminReportService extends HttpServiceBase {
  public getInstitutionAdminReportExportLink(): string {
    return `${this.httpClient.defaults.baseURL ?? ""}/institution-admin-report/export`;
  }
}
